import { COUPON_ADDON_POLICY_TYPE } from '@/enums/airport'

export const getStatusByCode = <T extends { [key: string]: number | string }, U extends { [key: string]: string }>(
  code: T[keyof T],
  codeEnum: T,
  statusEnum: U
): string => {
  const statusKey = Object.keys(codeEnum).find((key) => codeEnum[key] === code)

  return statusKey ? statusEnum[statusKey] : '-'
}

//추후 enum text 추가 예정
export const handleFormattingAddonLabel = (addonPolicyType: COUPON_ADDON_POLICY_TYPE) => {
  if (!addonPolicyType) return '-'
  switch (addonPolicyType) {
    case COUPON_ADDON_POLICY_TYPE.ADDITIONAL_CHARGE:
      return '추가요금'
    case COUPON_ADDON_POLICY_TYPE.VALET_PICKUP_SENDING:
      return '발렛/픽업 ∙ 샌딩'
    case COUPON_ADDON_POLICY_TYPE.LATE_NIGHT_ENTRY:
      return '심야입차'
    case COUPON_ADDON_POLICY_TYPE.LATE_NIGHT_EXIT:
      return '심야출차'
  }
}
